module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "do-button-and-date"
  }, [(_vm.isDatepickerOpen && _vm.selectedDate) ? _c('button', {
    staticClass: "do-bttn do-bttn__filter",
    on: {
      "click": function($event) {
        return _vm.$emit('dateChanged', null)
      }
    }
  }, [_vm._v("\n    Luk for fagønsker\n  ")]) : _vm._e(), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn__filter",
    on: {
      "click": function($event) {
        _vm.isDatepickerOpen = !_vm.isDatepickerOpen
      }
    }
  }, [(!_vm.selectedDate) ? [_vm._v("\n      " + _vm._s(_vm.isDatepickerOpen ? 'Slutdato for fagønsker' : 'Åbn for fagønsker') + "\n    ")] : _vm._e(), _vm._v(" "), (_vm.selectedDate) ? [_vm._v("\n      Slutdato for fagønsker\n      "), _c('div', {
    staticClass: "do-filters__divider"
  }), _vm._v(" "), _c('span', {
    staticClass: "do-badge"
  }, [_vm._v(_vm._s(_vm.selectedDateFormatted))])] : _vm._e()], 2), _vm._v(" "), (_vm.isDatepickerOpen) ? _c('div', {
    staticClass: "do-button-and-date__datepicker"
  }, [_c('DateSelector', {
    staticStyle: {
      "width": "210px"
    },
    attrs: {
      "isOpen": true,
      "isShowInput": false,
      "date": _vm.selectedDate ? _vm.selectedDate : new Date()
    },
    on: {
      "changed": function($event) {
        return _vm.setDate($event)
      },
      "close": function($event) {
        _vm.isDatepickerOpen = false
      }
    }
  })], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9de6840a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/DoButtonAndDate.vue
// module id = 1729
// module chunks = 1